import JsonManager from './JsonManager';

class FooterManager {
  static getFacebookLink() {
    return JsonManager.getLink('facebook');
  }

  static getTwitterLink() {
    return JsonManager.getLink('twitter');
  }

  static getYoutubeLink() {
    return JsonManager.getLink('youtube');
  }

  static getCopyright() {
    return JsonManager.getCopyright();
  }
}

export default FooterManager;



// WEBPACK FOOTER //
// ./src/managers/FooterManager.js